export const veryGood: string = '#1BCF42';
export const good: string = '#39ae8b';
export const moderate: string = '#ffb800';
export const unhealthy: string = '#ff5c00';
export const veryUnhealthy: string = '#dc2424';
export const levelColor: string[] = [veryGood,good, moderate, unhealthy,veryUnhealthy];

export const primaryColor: string = '#66BA7E';